import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminRoutingModule } from './admin-routing.module';
import { AdminComponent } from './admin.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthService } from 'src/app/services/auth.service';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { UsersComponent } from './users/users.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule } from '@ngx-translate/core';
import { LogsComponent } from './logs/logs.component';
import { QuotesComponent } from './quotes/quotes.component';
import { NgZorroModule } from '../ng-zorro.module';
import { ImagesComponent } from './images/images.component';
import { PipesModule } from '../pipes.module';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AdminComponent,
    UsersComponent,
    LogsComponent,
    QuotesComponent,
    ImagesComponent
],
  imports: [
    AdminRoutingModule,
    CommonModule,
    BrowserModule,
    NgZorroModule,
    PipesModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateModule,
          useFactory: createTranslateLoader, // exported factory function needed for AoT compilation
          deps: [HttpClient]
      }
    })
  ],
  exports: [AdminComponent],
  providers: [AuthService, AuthGuard],
})
export class AdminModule { }
